export default [{
    path: '/platform',
    component: "__base",
    children: [{
            path: 'console',
            component: 'AdminConsole/AdminConsoleLayout.vue',
            meta: { adminConsole: true, allow: true, requiresManager: true },
            redirect: 'console/agent-settings',
            children: [
                {
                    path: 'agent-settings',
                    component: 'AdminConsole/AgentSettingsLanding.vue',
                    meta: { title: 'Agent Settings', adminConsole: true, allow: true },
                },
                {
                    path: 'data-configuration',
                    component: 'AdminConsole/DataConfiguration.vue',
                    meta: { title: 'Data Configuration', adminConsole: true, allow: true, requiresManager: true },
                },
                {
                    path: 'accruals',
                    redirect: (to) => ({
                        path: '/platform/accruals-settings',
                        query: to.query,
                    }),
                },
            ],
        },
        {
            path: 'accruals-settings',
            component: 'AdminConsole/AccrualsAgentSettings.vue',
            meta: { title: 'Accruals Agent Settings', allow: true, hideSideNav: true, requiresManager: true },
        },
    ],
}, {
    path: '/admin',
    component: "__base",
    children: [{
            // module: "ADMIN",
            path: "roles",
            component: "Permission/Roles.vue",
            meta: { title: "Roles", right: "permission_role" },
        },
        {
            // module: "ADMIN",
            path: "rights",
            component: "Permission/Rights.vue",
            meta: { title: "Rights", right: "permission_right" },
        },
        {
            // module: "ADMIN",
            path: "bots",
            component: "Conserve/BotMaster.vue",
            meta: { title: "Analysis", right: "conserve_bots" },
        },
        {
            // module: "ADMIN",
            path: "user",
            component: "User.vue",
            meta: { title: "Users", right: "user" },
        },
        {
            // module: "ADMIN",
            path: "client",
            component: "Client.vue",
            meta: { title: "Entities", right: "client" },
        },
        {
            // module: "ADMIN",
            path: "client/id/:id",
            component: "ClientDetails.vue",
            meta: { title: "Entity Details", right: "client" },
        },

        {
            // module: "TDS",
            path: "area",
            component: "Conserve/Area.vue",
            meta: { title: "Area Master", right: "conserve_area" },
        },
        {
            // module: "TDS",
            path: "inputparameter",
            component: "Conserve/InputParam.vue",
            meta: { title: "Input Parameters", right: "conserve_input_parameter" },
        },
        {
            // module: "TDS",
            path: "file",
            component: "Conserve/FileMaster.vue",
            meta: { title: "File Master", right: "conserve_file" },
        },
        {
            // module: "TDS",
            path: "verification",
            component: "Conserve/Verification.vue",
            meta: { title: "Verification Master", right: "conserve_verification" },
        },
        {
            // module: "TDS",
            path: "products",
            component: "Subscription/SubscriptionProduct.vue",
            meta: { title: "Subscription Product", right: "subscription_product" },
        },
        {
            // module: "TDS",
            path: "plans",
            component: "Subscription/SubscriptionPlan.vue",
            meta: { title: "Subscription Plan", right: "subscription_plan" },
        },
        {
            // module: "TDS",
            path: "prompts",
            component: "Prompts/Prompts.vue",
            meta: { title: "Prompts", right: "subscription_plan" },
        },
        {
            // module: "TDS",
            path: "prompts/details/:feature?",
            component: "Prompts/PromptsDetails.vue",
            name: "PromptsDetails",
            meta: { title: "Prompt Details", right: "subscription_plan" },
        },

        {
            // module: "ADMIN",
            path: "*",
            component: "",
        },
    ],
}, ]